import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tabs } from 'antd';
import '../../../pages/client/client_assets/css/Setting.css'
import 'font-awesome/css/font-awesome.min.css';
// import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudArrowUp,faXmark } from '@fortawesome/free-solid-svg-icons';
// import Propic from '../../pages/assets/Propic.png'
import Defaultimg from '../../../pages/client/client_assets/img/Defaultimg.png'
// import ThemeModes from '../../pages/assets/ThemeModes.svg'
// import Themedark from '../../pages/assets/Themedark.svg'
import config from '../../../../src/config/config.js';

import { InboxOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Setting(){
  const [showSecondSection, setShowSecondSection] = useState(false);
  const [showDragDrop, setShowDragDrop] = useState(false);
  const [showUploadBox, setShowUploadBox] = useState(false);
  const [showNameSecondSection, setShowNameSecondSection] = useState(false);
  const [showPasswordSecondSection, setShowPasswordSecondSection] = useState(false);
  const [showLanguageSecondSection, setShowLanguageSecondSection] = useState(false);
  const [language, setLanguage] = useState('English'); 


  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');


  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [profilePicture, setProfilePicture] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${config.API_BASE_URL}/get-user-data-account1.php`, {
          withCredentials: true,
        });
        

        if (response.data.success) {
          setName(response.data.data || '');
          setRole(response.data.role || '');
          setEmail(response.data.email || '');
          setProfilePicture(response.data.profile_picture || '');
        } else {
          console.error('Error fetching user data:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching user data:', error.response?.data?.message || error.message);
      }
    };

    fetchUserData();
  }, []);

  const handleDeletePicture = async () => {
    try {
      const response = await axios.post(`${config.API_BASE_URL}/delete-profile-picture-account.php`, { email });
  
      if (response.data.success) {
        setProfilePicture(null);
        toast.success(response.data.message); // Success message from backend
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(response.data.message); // Error message from backend
      }
    } catch (error) {
      console.error('Error deleting profile picture:', error);
      toast.error('Failed to delete profile picture.');
    }
  };

  const handleUploadClick = () => {
    setShowSecondSection(true);
    setShowUploadBox(false);
    setShowDragDrop(true);
  };

  const handleCancelClick = () => {
    setShowSecondSection(false);
    setShowNameSecondSection(false);
    setShowPasswordSecondSection(false);
    setShowLanguageSecondSection(false);
  };
  const onChange = (key) => {
    console.log(key);
  };
// ///////

const secondHandleUploadClick = () => {
  setShowSecondSection(true);
  setShowDragDrop(true); 
};

const handleUploadButtonClick = () => {
  setShowDragDrop(false);
  setShowUploadBox(true); 
};

const secondHandleCancelClick = () => {
  setShowUploadBox(false); 
  setShowDragDrop(false); 
  setShowSecondSection(false); // Go back to first section
};
// /////name-part-onclick

const handleNameEditClick = () => {
  setShowNameSecondSection(true);
};

const handleNameSaveClick = async () => {
  if (!email || !name) {
    console.error("Email or name is missing.");
    return;
  }

  console.log("Payload:", { email, name }); // Debugging the payload

  try {
    const response = await axios.post(
      `${config.API_BASE_URL}/update-name-account.php`,
      {
        email,
        name,
      }
    );

    console.log("Response:", response.data); // Debugging the response

    if (response.data.success) {
      toast.success("Name updated successfully");
      setShowNameSecondSection(false);
    } else {
      toast.error(response.data.message || "Failed to update name.");
    }
  } catch (error) {
    console.error("Error updating name:", error);
    toast.error("Failed to update name.");
  }
};
// ///password-part-onclick

const handlePasswordResetClick = () => {
  setShowPasswordSecondSection(true);
};

const handlePasswordUpdateClick = async () => {
  if (newPassword !== confirmNewPassword) {
    toast.error('New password and confirmation do not match.');
    return;
  }

  if (!email) {
    console.error('Email not found in session storage');
    toast.error('Email not found. Please log in again.');
    return;
  }

  // Check if passwords meet minimum criteria
  if (newPassword.length < 6) {
    toast.error('Password must be at least 6 characters long.');
    return;
  }

  try {
    const response = await axios.post(`${config.API_BASE_URL}/update-password-account.php`, {
      email,
      currentPassword,
      newPassword,
    });

    // Check if response indicates success
    if (response.data.success) {
      toast.success('Password updated successfully');
      setShowPasswordSecondSection(false); // Hide password section after success
      setCurrentPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    } else {
      // If success is false, show the error message returned from the server
      toast.error(response.data.message || 'Failed to update password.');
    }
  } catch (error) {
    // If the error response is available, check the status code
    if (error.response && error.response.status === 401) {
      toast.error('Current password is incorrect.');
    } else {
      toast.error('Failed to update password.');
    }
    console.error('Error updating password:', error);
  }
};

const { Dragger } = Upload;
const uploadProps = {
  name: 'profile_pic',
  action: `${config.API_BASE_URL}/update-profile-picture-account.php`,
  // headers: {
  //   Authorization: `Bearer ${sessionStorage.getItem('token')}`, // Optional: Include auth token if required
  // },
  data: { email },
  multiple: false,
  showUploadList: false,
  beforeUpload: (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      toast.error('Only JPG/PNG files are allowed!');
    }
    return isJpgOrPng;
  },
  onChange(info) {
    const { status } = info.file;
    if (status === 'done') {
      setProfilePicture(URL.createObjectURL(info.file.originFileObj));
      toast.success('Profile picture uploaded successfully.');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else if (status === 'error') {
      toast.error('Failed to upload profile picture.');
    }
  },
  onDrop(e) {
    console.log('Dropped files', e.dataTransfer.files);
  },
};






const items = [
  {
    key: '1',
    label: '',
    children: (
    <>
    <div className="profile-container">

   
    <div className="sttg-hr"></div>
    <div className="profilepicture-part">
    {/* First Section */}
    {!showSecondSection && (
      <div className="profile-firstsection">
        <div className="profilename">
          <h4>Profile Picture</h4>
        </div>
        <div className="profileimgpart">
          <div className="pro-img">
          <img src={profilePicture ? `${config.API_BASE_URL}/uploads/${profilePicture}` : Defaultimg} alt="Profile" />

          </div>
          <div className="profilenamesecond">
            <p>Max File size - 5MB</p>
          </div>
        </div>
        <div className="upload-btn">
          <button className="dltbtn" onClick={handleDeletePicture}>Delete</button>
          <button className="upldbtn" onClick={handleUploadClick}>Upload</button>
        </div>
      </div>
    )}

    {/* Second Section */}
    {showSecondSection && (
      <div className="profile-secondsection">
        <div className="profilename">
          <h4>Profile Picture</h4>
        </div>
        <div className="dragand-btn-main">
          {showDragDrop && (
            <Dragger {...uploadProps}>
              <p className="ant-upload-drag-icon">
                <FontAwesomeIcon icon={faCloudArrowUp} />
              </p>
              <p className="ant-upload-text">
                <a className="click-link">Click to upload</a> or drag and drop PNG/JPG
              </p>
              <p className="ant-upload-hint">Max File size - 5MB</p>
            </Dragger>
          )}
          <div className="upload-btn">
            <button className="cancelbtn" onClick={handleCancelClick}>Cancel</button>
          </div>
        </div>
        {/* This is just for adding the space and it is not required any actions (do not consider this button) */}
      <div className="password-btn" style={{visibility: "hidden"}}>
      <button className="pass-cancelbtn" onClick={handleCancelClick} >Cancel</button>
    </div>

      </div>
    )}
  </div>

<div className="sttg-hr"></div>
           
<div className="name-part">
{/* First Section */}
{!showNameSecondSection ? (
  <div className="name-firstsection">
    <div className="name">
      <h4>Name</h4>
    </div>
    <div className="rapidpricer-name">
      <p>{name || 'BYB'}</p>
    </div>
    <div className="pro-edit-btn">
      <button onClick={handleNameEditClick}>Edit</button>
    </div>
  </div>
) : (
  /* Second Section */
  <div className="name-secondsection">
    <div className="name">
      <h4>Name</h4>
    </div>
    <div className="name-rightcontent">
      <p>Edit Name*</p>
      <input
        type="text"
        id="fname"
        name="fname"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <div className="name-btns">
        <button className="name-savebtn" onClick={handleNameSaveClick}>
          Save
        </button>
        <button className="name-cancelbtn" onClick={handleCancelClick}>
          Cancel
        </button>
      </div>
    </div>

    {/* Hidden Button for Layout Consistency */}
    <div className="password-btn" style={{ visibility: "hidden" }}>
      <button className="pass-cancelbtn" onClick={handleCancelClick}>Cancel</button>
    </div>
  </div>
)}
</div>


<div className="sttg-hr"></div>

<div className="password-part">
    {/* First Section */}
    {!showPasswordSecondSection && (
      <div className="password-firstsection">
        <div className="password">
          <h4>Password</h4>
        </div>
        <div className="pass-dots">
          <p>.........</p>
        </div>
        <div className="reset-btn">
          <button onClick={handlePasswordResetClick}>Reset</button>
        </div>
      </div>
    )}

    {/* Second Section */}
    {showPasswordSecondSection && (
      <div className="password-secondsection">
        <div className="password">
          <h4>Password</h4>
        </div>
        <div className="password-rightcontent">
          <p>Enter current password*</p>
          <input
            type="password"
            placeholder="Enter old password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <div className="password-inputs">
            <div>
              <p>Create new password*</p>
              <input
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <div>
              <p>Confirm new password*</p>
              <input
                type="password"
                placeholder="Enter new password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
            </div>
          </div>
          <div className="password-btn">
            <button className="update-passbtn" onClick={handlePasswordUpdateClick}>Update Password</button>
            <button className="pass-cancelbtn" onClick={handleCancelClick}>Cancel</button>
          </div>
        </div>
        {/* This is just for adding the space and it is not required any actions (do not consider this button) */}
        <div className="password-btn" style={{visibility: "hidden"}}>
          <button className="pass-cancelbtn" onClick={handleCancelClick} >Cancel</button>
          </div>
      </div>
    )}
  </div>
<div className="sttg-hr"></div>

<div className="role-part">
   <div className="role">
 <h4>Role</h4>
   </div>

   <div className="role-admin-name">
   <p>Account User</p>
   </div>

    {/* This is just for adding the space and it is not required any actions (do not consider this button) */}
   <div className="password-btn" style={{visibility: "hidden"}}>
    <button className="pass-cancelbtn" onClick={handleCancelClick} >Cancel</button>
  </div>

</div>
<div className="sttg-hr"></div>
</div>
    </>)
  },

];
 
return(
    <>

<div className="container-fluid setting_sec">
                <div className="d-sm-flex align-items-center justify-content-between mb-2">
                    <h1 className="dashboard_heading">Settings</h1>
                </div>
                 <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
       
      </div>

      <ToastContainer />
    </>
)

}
export default Setting;